import React from 'react';
import { CHECKOUT_URL, PURCHASE_ANCHOR } from '../data/content';
interface CTAButtonProps {
  label: string;
  sub?: string;
  target?: 'purchase' | 'checkout';
  tone?: 'electric' | 'magenta';
  className?: string;
}
const tones = {
  electric: 'bg-electric text-navy shadow-[0_5px_0_0_theme(colors.electric.dark)] active:shadow-[0_2px_0_0_theme(colors.electric.dark)]',
  magenta: 'bg-magenta text-white shadow-[0_5px_0_0_theme(colors.magenta.dark)] active:shadow-[0_2px_0_0_theme(colors.magenta.dark)]'
};
export function CTAButton({
  label,
  sub,
  target = 'purchase',
  tone = 'electric',
  className = ''
}: CTAButtonProps) {
  return <a href={target === 'checkout' ? CHECKOUT_URL : PURCHASE_ANCHOR} className={`block w-full rounded-md border-2 border-white/40 px-3 py-3 text-center font-heading text-[0.95rem] font-extrabold uppercase leading-tight tracking-wide transition-[filter,transform,box-shadow] duration-150 ease-out hover:brightness-110 active:translate-y-[3px] focus:outline-none focus-visible:ring-4 focus-visible:ring-blush sm:text-lg ${tones[tone]} ${className}`} data-id="element-30" data-mp="33r8s164s6bnj">
      {label}
      {sub ? <span className="mt-0.5 block font-body text-xs font-semibold normal-case tracking-normal opacity-90" data-id="element-31" data-mp="1dckpvleui1mo">
          {sub}
        </span> : null}
    </a>;
}